import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ label, title, sub, align = "center" }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-14 md:mb-20`}>
    <p className="text-sm uppercase tracking-[0.2em] font-bold text-blue-400 mb-4">{label}</p>
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-extrabold text-white leading-tight">{title}</h2>
    {sub && <p className="mt-5 text-base sm:text-lg text-slate-400 leading-relaxed">{sub}</p>}
  </Reveal>
);
